/**
 * @file     PoweredByRealtorCa.tsx
 * @purpose  DDF Rule 6(a)(i): listings sourced from the CREA National Shared
 *           Pool must display the "Powered by REALTOR.ca" logo, min 90px wide
 *           at 1:1 ratio, linking directly to the corresponding listing on
 *           REALTOR.ca. Renders nothing for non-DDF (Bridge/curated) listings.
 *
 * Asset: official CREA REALTOR.ca mark at /public/realtor-ca/powered-by-realtor-ca.svg
 * (square, rendered at 90px to meet the 1:1 / min-90px rule). The <img> alt text
 * is the required text fallback.
 */

'use client';

import Box from '@mui/material/Box';

type Props = {
  /** 'ddf' enables the badge; anything else renders null. */
  feedProvider: string | null;
  /** realtor.ca deep link for this listing. */
  realtorCaUrl: string | null;
};

export function PoweredByRealtorCa({ feedProvider, realtorCaUrl }: Props) {
  if (feedProvider !== 'ddf' || !realtorCaUrl) return null;

  return (
    <Box sx={{ py: 2 }}>
      <a
        href={realtorCaUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Powered by REALTOR.ca. View this listing on REALTOR.ca"
        style={{ display: 'inline-block', lineHeight: 0 }}
      >
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src="/realtor-ca/powered-by-realtor-ca.svg"
          alt="Powered by REALTOR.ca"
          width={90}
          height={90}
          style={{ width: 90, height: 90, objectFit: 'contain' }}
        />
      </a>
    </Box>
  );
}
